// ======================================================================
// File Name       : EnterpriseRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues, submit } from 'redux-form';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import * as modalActions from '../../actions/ModalAction';
import EnterpriseEditForm from '../../components/enterprise/EnterpriseEditForm';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { ENTERPRISE_LAYER_L0, PRICE_PLAN } from '../../constants/EnterpriseConstants';
import { ENTERPRISE_CONFIRM, ENTERPRISE_EDIT, ENTERPRISE_REGISTER } from '../../constants/ModalIds';
import { DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../../constants';
import * as utils from '../../utils';

class EnterpriseRegisterEditContainer extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  submitForm() {
    const { dispatch } = this.props;
    dispatch(submit('enterpriseEditForm'));
  }

  getModalOptions() {
    const { modalId } = this.props;

    const footerBtns = [
      { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
      { name: 'OK', onClick: this.submitForm, variant: 'primary' },
    ];

    const options = {
      [ENTERPRISE_REGISTER]: {
        title: '企業情報の新規登録',
        footerBtns,
      },
      [ENTERPRISE_EDIT]: {
        title: '企業情報の編集',
        footerBtns,
      },
    };

    return options[modalId];
  }

  handleSubmit(formValues) {
    const { dispatch } = this.props;
    const params = formValues;
    const { usageSettingInfo, parentEnterpriseInfo } = params;
    const { parentPricePlan, parentEnterpriseLayer } = parentEnterpriseInfo;
    if (usageSettingInfo.pricePlan === undefined) {
      usageSettingInfo.pricePlan = parentEnterpriseLayer === ENTERPRISE_LAYER_L0 ? PRICE_PLAN.NEW : parentPricePlan;
    } else if (usageSettingInfo.pricePlan === PRICE_PLAN.OLD && usageSettingInfo.pricePlanUpdateReservedFlag === true) {
      usageSettingInfo.pricePlan = PRICE_PLAN.NEW;
    }

    dispatch(enterpriseActions.updateEnterprise(params));
    dispatch(modalActions.openModal(ENTERPRISE_CONFIRM));
  }

  // sprint_20230403 #4 START
  handleTimeChange(name, value) {
    const { dispatch } = this.props;
    // update form
    dispatch(change('enterpriseEditForm', [name], value));
    // update 利用開始日
    const params = {
      [name]: value,
    };
    dispatch(enterpriseActions.updateEnterprise(params));
  }
  // sprint_20230403 #4 END

  render() {
    const {
      editingEnterprise,
      editMode,
      userInfo: { displayUserType },
      rootFlag,
      enterpriseCdLogin,
      isEnterpriseNotChild,
    } = this.props;
    // Step 12.0.0 TAS-18710 START
    const isEditLoggedInEnterprise =
      utils.isSuperUserL1(displayUserType) && rootFlag && enterpriseCdLogin === editingEnterprise.enterpriseCd;
    // Step 12.0.0 TAS-18710 END

    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <EnterpriseEditForm
          editMode={editMode}
          onSubmit={this.handleSubmit}
          handleTimeChange={this.handleTimeChange} // sprint_20230403 #4
          isEditLoggedInEnterprise={isEditLoggedInEnterprise} // Step 12.0.0 TAS-18710
          isEnterpriseNotChild={isEnterpriseNotChild}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { editingEnterprise, editMode, isEnterpriseNotChild } = state.enterprise;
  const { userInfo, enterpriseCd, rootFlag } = state.authed.authedUser;
  return {
    editingEnterprise,
    editMode,
    userInfo,
    rootFlag,
    enterpriseCdLogin: enterpriseCd,
    isEnterpriseNotChild,
  };
};
export default connect(mapStateToProps)(EnterpriseRegisterEditContainer);
